import { useTranslation } from 'react-i18next';
import { Field, Input } from '../../components/ui.tsx';

/** Ato formal de nomeação no formulário (especificação de alçadas, entrega 5). */
export type ActForm = { justification: string; evidenceRef: string; validUntil: string };

export const emptyAct = (): ActForm => ({ justification: '', evidenceRef: '', validUntil: '' });

/** Corpo do ato para a API; sem justificativa, não vai (o servidor exige quando a pessoa muda). */
export function actPayload(a: ActForm | undefined) {
  if (!a || !a.justification.trim()) return undefined;
  return {
    justification: a.justification.trim(),
    evidenceRef: a.evidenceRef.trim() || null,
    validUntil: a.validUntil || null,
  };
}

/**
 * Campos do ato de nomeação: aparecem quando a pessoa nomeada muda. Justificativa obrigatória;
 * referência da evidência e vigência opcionais (aviso 30 dias antes e encerramento no vencimento).
 */
export function AppointmentActFields({
  title,
  value,
  onChange,
}: {
  title: string;
  value: ActForm;
  onChange: (patch: Partial<ActForm>) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-2 rounded-md border border-rule p-3 sm:col-span-2">
      <span className="text-sm font-medium">{title}</span>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <Field label={t('appointments.justification')} hint={t('appointments.justificationHint')}>
          <Input
            required
            minLength={10}
            maxLength={1000}
            value={value.justification}
            onChange={(ev) => onChange({ justification: ev.target.value })}
          />
        </Field>
        <Field label={t('appointments.evidenceRef')} hint={t('appointments.evidenceHint')}>
          <Input
            maxLength={500}
            value={value.evidenceRef}
            onChange={(ev) => onChange({ evidenceRef: ev.target.value })}
          />
        </Field>
        <Field label={t('appointments.validUntil')} hint={t('appointments.validUntilHint')}>
          <Input
            type="date"
            value={value.validUntil}
            onChange={(ev) => onChange({ validUntil: ev.target.value })}
          />
        </Field>
      </div>
    </div>
  );
}
